import { WorkspaceActionTypes, WorkspacesActions } from "./workspaces.actions";
import { Workspace } from "./workspaces.model";

export const workspacesFeatureKey = "workspaces";

export interface WorkspacesState {
  workspaces: Workspace[] | null;
  loading: boolean;
  loadError: any;
}

export const initialWorkspacesState: WorkspacesState = {
  workspaces: null,
  loading: false,
  loadError: null,
};

export function workspacesReducer(
  state = initialWorkspacesState,
  action: WorkspacesActions,
): WorkspacesState {
  switch (action.type) {
    case WorkspaceActionTypes.LoadWorkspaces:
      return Object.assign({}, state, { loading: true, loadError: null });

    case WorkspaceActionTypes.LoadWorkspacesFailure:
      return Object.assign({}, state, {
        loading: false,
        loadError: action.error,
      });

    case WorkspaceActionTypes.SetWorkspaces:
      return Object.assign({}, state, {
        workspaces: action.workspaces,
        loading: false,
        loadError: null,
      });

    default:
      return state;
  }
}
